import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class ArticleAction extends Model {
    @observable actions = [];
}
